<template>
    <div class="detail-frame-mobile-container">
        <div class="banner">
            <img :src="baseInfo.icon" alt="">
        </div>
        <div class="product-info">
            <h2 class="product-title">{{ baseInfo.title }}</h2>
            <p class="product-subtitle">{{ baseInfo.des }}</p>
            <div class="product-price">
                <span class="price">{{ baseInfo.price }}</span>
                <span class="unit">{{ baseInfo.unit }}</span>
                <span v-show="baseInfo.isShowPriceIcon" class="price-icon"></span>
                <span v-show="baseInfo.isShowOriginPrice" class="origin-price">市场价：</span>
                <span v-show="baseInfo.isShowOriginPrice" class="origin-price center-line">
                    {{ baseInfo.originPrice }}
                </span>
            </div>
            <div class="product-tip">
                <div v-for="(item, index) in baseInfo.tips" :key="index">
                    <i :class="item.className"></i>
                    <span>{{ item.text }}</span>
                </div>
            </div>
        </div>
        <div class="product-detail-tab">
            <div class="product-detail-tab-main">
                <span
                    v-for="(item, index) in tabList"
                    :key="index"
                    :class="{active: activetab === item.value}"
                    @click="onScrollDetail(index)"
                >{{ item.text }}</span>
            </div>
        </div>
        <div ref="tab" class="product-detail-wrap">
            <slot name="product-detail"/>
        </div>
        <div class="fixed-part">
            <button class="btn-deep" @click="showPayDrawer">立即购买</button>
            <button class="btn-easy" @click="onShowDialog">免费咨询</button>
        </div>
        <consult-dialog
            :is-show="isShowDialog"
            :biz-type="bizType"
            @onHide="onHideDialog"
        />
        <el-drawer
            :title="baseInfo.drawerTitle"
            direction="btt"
            size="auto"
            :visible.sync="drawer"
        >
            <div class="form-wrap">
                <slot name="drawer"/>
            </div>
            <div class="form-confirm">
                <div class="form-item-agreement">
                    <span
                        :class="{'form-item-radius': true, 'agreed': isAgree}"
                        @click="isAgree = !isAgree"
                    ></span>
                    <span>同意并接受</span>
                    <a href="https://console.bce.baidu.com/iam/agreement-v2.html">
                        《百度智能云用户隐私协议》
                    </a>
                </div>
                <button :class="{disable: !isAgree}" @click="onToBuy">下一步</button>
            </div>
        </el-drawer>
    </div>
</template>

<script>

import ConsultDialog from './consultDialog.vue';
import {isOnline} from '../../util/helper';

export default {
    components: {
        ConsultDialog
    },

    props: {
        bizType: {
            type: String,
            default: 'COMREG'
        },
        activetab: {
            type: String,
            default: 'intro'
        },
        baseInfo: {
            type: Object,
            default: () => {
                return {};
            }
        },
        tabList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },

    data() {
        return {
            isShowDialog: false,
            scrollHeightList: [],
            drawer: false,
            isAgree: true
        };
    },

    created() {
        let scriptNode = document.createElement('script');
        let scriptSrc = isOnline
            ? 'https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common/load.online.js'
            : 'https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common/load.sandbox.js';
        scriptNode.setAttribute('src', scriptSrc);
        scriptNode.onload = () => {
            if (window.portalCommon) {
                window.portalCommon.setup({
                    showHeader: true,
                    showPcFooter: false
                });
            }
        };
        document.head.appendChild(scriptNode);
    },

    mounted() {
        this.setScrollHeightList();
    },

    methods: {
        setScrollHeightList() {
            if (!this.$refs.tab) {
                return;
            }
            const tabItem = this.$refs.tab.children;
            const scrollHeightList = [];
            for (let i = 0; i < Object.keys(tabItem).length; i++) {
                scrollHeightList.push(tabItem[Object.keys(tabItem)[i]].offsetTop - 56);
            }
            this.scrollHeightList = scrollHeightList;
        },

        onScrollDetail(index) {
            window.scrollTo({
                top: this.scrollHeightList[index],
                behavior: 'smooth'
            });
        },

        onHideDialog() {
            this.isShowDialog = false;
        },

        onShowDialog() {
            this.isShowDialog = true;
        },

        showPayDrawer() {
            this.drawer = true;
        },

        onToBuy() {
            if (!this.isAgree) {
                return;
            }
            this.$emit('onToBuy');
        }
    }
};
</script>

<style lang="less">
.cloud-header-wap {
    z-index: 777 !important;
}

.detail-frame-mobile-container {
    background-color: #f5f5f5;
    .banner {
        height: 55rem;
        max-height: 300px;
        width: 100%;
        img {
            width: 100%;
            height: 100%;
        }
    }

    .fixed-part {
        width: 100%;
        height: 9.8rem;
        max-height: 49px;
        position: fixed;
        background-color: #fff;
        display: flex;
        left: 0;
        bottom: 0;
        justify-content: space-between;
        align-items: center;
        padding: 0 3.4rem;
        border-top: 0.1rem solid #DCDFE6;
        button {
            width: 32.6rem;
            height: 8rem;
            max-height: 40px;
            font-family: PingFangSC-Regular;
            font-size: 2.8rem;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            border-radius: 4px;
            border: none;
        }
        .btn-deep {
            color: #FFFFFF;
            background: #2A62FE;
        }
        .btn-easy {
            color: #2A62FE;
            background: #fff;
            border: 0.2rem solid #2A62FE;
        }
    }

    .product-detail-wrap {
        margin-top: 3rem;
    }

    .product-info {
        padding: 3rem 3.4rem;
        background-color: #fff;
    }

    .product-title {
        font-family: PingFangSC-Medium;
        font-size: 3.2rem;
        color: #191C3D;
        letter-spacing: 0;
        font-weight: 500;
        margin: 0;
    }

    .product-subtitle {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 2.6rem;
        color: #191C3D;
        letter-spacing: 0;
        font-weight: 400;
        margin: 1.2rem 0 2rem 0;
    }

    .product-price {
        span {
            vertical-align: middle;
            font-family: PingFangSC-Regular;
            font-size: 2.6rem;
            color: #A5ABBC;
            letter-spacing: 0;
            font-weight: 400;
        }
        .price {
            font-family: PingFangSC-Medium;
            font-size: 4rem;
            color: #F02323;
            letter-spacing: 0;
            font-weight: 500;
        }
        .unit {
            margin: 0 1rem;
        }
    }

    .product-tip {
        display: flex;
        flex-wrap: wrap;
        >div {
            display: flex;
            align-items: center;
            margin-top: 2rem;
        }
        >div:nth-child(2n) {
            margin-left: 4rem;
        }
        span {
            font-family: PingFangSC-Regular;
            font-size: 2.8rem;
            color: #2A62FE;
            font-weight: 400;
            margin-left: 2rem;
        }
    }

    .price-icon {
        display: inline-block;
        width: 10.6rem;
        height: 3.4rem;
        background-size: 100% 100%;
        background-image: url(../../assets/mobile/bkp/dacu.png);
        margin-right: 3rem;
    }

    .fast-icon,
    .consult-icon,
    .cbs-icon {
        display: inline-block;
        width: 2.8rem;
        height: 2.8rem;
        background-size: 100% 100%;
    }

    .fast-icon {
        background-image: url(../../assets/mobile/cbs/fast-icon.png);
    }

    .consult-icon {
        background-image: url(../../assets/mobile/cbs/consult-icon.png);
    }

    .cbs-icon {
        background-image: url(../../assets/mobile/cbs/cbs-icon.png);
    }

    .product-detail-tab {
        margin-top: 3rem;
        .product-detail-tab-main {
            height: 9.8rem;
            background-color: #fff;
            display: flex;
            align-items: center;
            overflow-x: scroll;
            padding: 0 1.4rem;
            scrollbar-width: none;
            -ms-overflow-style: none;
            &::-webkit-scrollbar {
                display: none;
            }
            span {
                margin: 0 2rem;
                font-family: PingFangSC-Regular;
                font-size: 3.2rem;
                color: #5E6178;
                letter-spacing: 0;
                font-weight: 400;
                white-space: nowrap;
            }
            span.active {
                color: #2A62FE;
                position: relative;
                &::after {
                    content: '';
                    bottom: -1rem;
                    left: 50%;
                    transform: translateX(-50%);
                    position: absolute;
                    background: #2A62FE;
                    border-radius: 1.5px;
                    width: 6.8rem;
                    height: 0.3rem;
                }
            }
        }
    }

    .specity-color {
        background-color: #f5f9ff;
        padding-bottom: 4rem;
    }

    .center-line {
        text-decoration: line-through;
    }

    .form-wrap {
        max-height: 60rem;
        overflow-y: scroll;
    }

    .form-confirm button {
        width: 100%;
        height: 8rem;
        max-height: 40px;
        background: #2a62fe;
        border-radius: 0.4rem;
        font-family: PingFangSC-Regular;
        font-size: 2.8rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        border: none;
        transition: 0.3s all;

        &.disable {
            background: #dcdfe6;
            border-radius: 0.4rem;
            color: #fff;
            cursor: no-drop;
        }
    }

    .form-item-agreement {
        margin: 2rem 0 3rem 0;
        span,
        a {
            font-size: 14px;
        }
        a {
            color: #2A62FE;
            text-decoration: none;
        }
    }

    .form-item-radius {
        display: inline-block;
        width: 2.6rem;
        height: 2.6rem;
        opacity: 0.3;
        border: 0.1rem solid #1B1E3F;
        border-radius: 50%;
        margin-right: 2rem;
        vertical-align: middle;
    }

    .form-item-radius.agreed {
        background-image: url(../../assets/mobile/cbs/gou2.png);
        background-size: 100% 100%;
        opacity: 1;
        border: none;
    }

    .el-drawer__header {
        margin: 0 0 3rem 0;
        text-align: center;
        padding: 0;
        span {
            font-family: PingFangSC-Medium;
            font-size: 3.2rem;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 500;
        }
    }

    .setting-form-wrap {
        input {
            color: #1b1e3f;
            transition: 0.3s all;
            border: 0.1rem solid #E1E6F0;
            border-radius: 0.4rem;
            background: #fff;
            outline: none;
            font-family: PingFangSC-Regular;
            font-size: 2.6rem;
            letter-spacing: 0;
            font-weight: 400;
            &::placeholder {
                opacity: 0.5;
            }
            &:focus {
                border-color:#2a62fe;
            }
            &.input-error {
                border-color:#f34f4f;
            }
        }

        .error-text {
            color: #f34f4f;
            font-size: 2rem;
        }

        .setting-form-item {
            margin-bottom: 3rem;
            .setting-form-item-label {
                opacity: 0.8;
                font-family: PingFangSC-Regular;
                font-size: 2.8rem;
                color: #1B1E3F;
                letter-spacing: 0;
                font-weight: 400;
                margin-bottom: 1.8rem;
            }

            .is-required {
                opacity: 0.8;
                font-family: PingFangSC-Regular;
                font-size: 2.8rem;
                color: #F02323;
                letter-spacing: 0;
                font-weight: 400;
            }

            .setting-sms-code {
                display: flex;
            }

            .setting-checkbox-wrap {
                display: flex;
                flex-wrap: wrap;
                button {
                    padding: 1.5rem 3rem;
                    font-family: PingFangSC-Regular;
                    font-size: 2.6rem;
                    color: #1B1E3F;
                    letter-spacing: 0;
                    font-weight: 400;
                    background-color: #fff;
                    border: 0.1rem solid #dcdfe6;
                    border-radius: 0.4rem;
                    margin: 0 3rem 2rem 0;
                    transition: 0.3s all;
                }
                button.active {
                    color: #2a62fe;
                    background-color: #EFF3FE;
                    border-color: #2a62fe;
                }
            }

            input {
                width: 100%;
                padding: 1.5rem 2rem;
                box-sizing: border-box;
                border-radius: 0.4rem;
                height: auto;
                line-height: 1;
            }

            .wrap-margin {
                margin-bottom: -3rem;
            }

            .el-input__icon {
                height: auto;
                line-height: 2.5;
            }

            .el-select {
                width: 100%;
            }

        }
    }
}
</style>